import { observer } from 'mobx-react-lite';
import VideoCard from "../../components/VideoCard/VideoCard";
import VideoListStore from "../../store/VideoListStore";
import Button from '../../ui/Button/Button';
import LanguageStore from "../../store/LanguageStore";
import './video-card-list.scss';

const VideoCardList = observer(() => {
    const {videoList, page, loading, buttonLoading, error, hasMorePages} = VideoListStore;
    const t = LanguageStore.t;
    const isDev = process.env.NODE_ENV !== 'production';

    const loadMore = () => {
        VideoListStore.setPage(page + 1);
        VideoListStore.loadMoreVideoList();
    }

    if (loading) {
        return (
            <section className="video-list">
                {Array.from({ length: 5 }).map((_, i) => (
                    <div key={i} className="video-list__loader"></div>
                ))}
            </section>
        );
    }

    if (error) return (
        <p>Unknown error</p>
    );

    if (videoList.length) return (
        <section className="video-list">
            {videoList.map((video, index) => {
                return <VideoCard key={video.videoId || video.video_id} video={video} isFirst={index === 0}/>
            })}

            {hasMorePages && (
                <Button
                    text={t("loadMore")}
                    onClick={loadMore}
                    loading={buttonLoading}
                />
            )}
            
            {isDev && (
                <div style={{background: 'yellow', padding: '10px', margin: '10px'}}>
                    DEBUG: hasMorePages = {hasMorePages.toString()}, 
                    videoList.length = {videoList.length}, 
                    page = {page}
                </div>
            )}
        </section>
    );

    if (!videoList.length) return (
        <div className="videos-not-found">
            {t('videosNotFound')}
        </div>
    )
});

export default VideoCardList;